import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/scss/material-dashboard-pro-react.scss?v=1.8.0';
import App from './App';
import { Provider } from 'react-redux';
import store, { persistor } from 'redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { ThroughProvider } from 'react-through';

ReactDOM.render(
	<ThroughProvider>
		<Provider store={store}>
			<PersistGate persistor={persistor} loading={null}>
				<App />
			</PersistGate>
		</Provider>
	</ThroughProvider>,
	document.getElementById('root')
);
